import { FC } from 'react';

import { CountryEntity } from 'api/types/entity';
import { lodash } from 'helpers';
import { useTranslation } from 'libs/i18n';
import { ROUTES, useNavigate } from 'libs/navigation';
import { ClientsOrLegalClientsView } from 'modules/client/common/views';

import { ClientsTableProps, ClientsTable, ClientsFilters } from '../components';
import { ClientFilterType } from '../types';

export interface ClientsViewProps extends ClientsTableProps {
  filter: ClientFilterType;
  setFilter: (filter?: ClientFilterType | undefined) => void;
  registrationCountries?: CountryEntity[];
  locationCountries?: CountryEntity[];
}

export const ClientsView: FC<ClientsViewProps> = ({
  setFilter,
  filter,
  registrationCountries,
  locationCountries,
  ...tableProps
}) => {
  const { t } = useTranslation();
  const { navigate } = useNavigate();

  const { search } = filter;

  const countFilter =
    lodash.defaultTo([filter?.onboardingStatuses?.length], 0) +
    lodash.defaultTo([filter?.riskLevels?.length], 0) +
    lodash.defaultTo([filter?.locationCountries?.length], 0) +
    lodash.defaultTo([filter?.registrationCountries?.length], 0);

  const noRowsLabel =
    (!!countFilter && t('components.table.filterEmptyData')) ||
    (!!search && t('components.table.searchEmptyData')) ||
    undefined;

  const handleAddClick = () => {
    navigate(ROUTES.clients.personClients.createPersonClient.fullPath, {});
  };

  return (
    <ClientsOrLegalClientsView
      filter={filter}
      FilterComponent={ClientsFilters}
      locationCountries={locationCountries}
      registrationCountries={registrationCountries}
      setFilter={setFilter}
      toggleButtonValue="person"
      onClickAdd={handleAddClick}
    >
      <ClientsTable {...tableProps} noRowsLabel={noRowsLabel} />
    </ClientsOrLegalClientsView>
  );
};
